(function Module() {
	'use strict';
	mySynch.controller('PublishedReportV1_3Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'F360Service',
		'AuditService',
		'ApiFactory',
		'CookieFactory',
		'F360Constant',
		'F360ChartService',
		'$location',
		'$filter',
		'$window',
		'ViewAuthorizationFactory',
		'MySynchFactory',
		'mySynchEnumerationService',
		'clientLoggerService',
		function PublishedReportV1_3Controller($s,$rootScope,$interval,$q, f360Service, auditService,api,cookies,constant, ChartService, $location,$filter,$window,viewAuth,MSF,mySynchEnumSvc, log) {
			window.scrollTo(0, 0);
			console.log("@@@@@@@@@ V1.3 Published Report @@@@@@@@");
		//	var publishedDate = '12/18/2019';
		    self.auditId = auditService.getAuditId($location.url());
			$s.breadcrumbs = [];
			$s.lastBreadcrumbs = {};

			$s.isOnline = $rootScope.onLine;
			
			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};


			$s.overViewList = [];
			$s.auditAnswers = [];
			$s.auditQuestions = [];

			$s.sectionsQuestionsAndAnswers = [];
			$s.actionItems = [];
			$s.defaultReportData = {"resultsWriteRptJson":{"formattedHighlights":"","nextEvaluationDate":"","comments":[{"section": "FARMWALKTHRU","formattedComments":""},{"section": "INTERVIEW","formattedComments":""},{"section": "DATAQUALITY","formattedComments":""},{"section": "REPRODUCTIVITY","formattedComments":""},{"section": "FRESHCOWDISEASE","formattedComments":""}]},"reviewDraftRptJson":{"reportDate":"","milkingCnt": null,"pregRate":null,"concRate":null}};
			$s.reportData = {};
			$s.report = angular.copy($s.defaultReportData);
			
			
			$s.actionItemStatuses = [];


			$s.followupItems = [];

			$s.actionItemGroups = [];
			$s.v2ActionItems = [];

			$s.auditApiVersion;

			$s.codeFile = [];


            let testActionItemGroup = {
				actionItemGroupKey: "Fertility",
				description: "test action group involving Fertility",
				actionItems: [],
				associatedMetrics: ""
			};

			let testAssociatedMetrics = [
				{
					name: "Pregnancy Rate RHA"
				},
				{
					name: "Conception Rate RHA"
				}
			];

			

			let testActionItems = [
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,15)).format('M/D/YYYY'),
					description: "This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. ",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"

				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,16)).format('M/D/YYYY'),
					description: "This is a list of actions to complete to meet the goal.",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,17)).format('M/D/YYYY'),
					description: "Description goes here.",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				}
			];

			$s.codeFile = [];
			var codeFileJSON = localStorage.getItem('codeFile');
			if(!_.isUndefined(codeFileJSON)){
			   try{
				   $s.codeFile = JSON.parse(codeFileJSON);
			   }catch(e){
			      log.info("Published Report: code file failed to be acquired from LocalStorage or failed to be parsed");
			   }
			}
			
			$s.auditApiVersion;
			
			$s.currentAuditApiVersion;

			var currentAuditApiVersionJsonArray =  JSON.parse(_.get(_.find($s.codeFile,{codeType: "CURRENTAPIVERSIONS",code:"AUDIT"}),'detailsJson'));
			$s.currentAuditApiVersion = _.get(currentAuditApiVersionJsonArray[0],'value');

			//------ chart model and data related variables
			$s.allMetGuidelineQuestions = [];
			$s.allOutsideGuidelineQuestions = [];
			$s.allMetGuidelineQuestionsWithGuidelines = [];
			$s.allOutsideGuidelineQuestionsWithGuidelines = [];


			$s.overallSummaryPieChart = {
				chart: {},
				title: "",
				seriesData: [] 
			};
			$s.sectionPieCharts = [];
            $s.sectionBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
			$s.categoryBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
              
			$s.questionSectionsPieChartData = [];
		 
			$s.codeFileQuestionCategories = _.filter(_.filter($s.codeFile,{codeType: "F360CATEGORY"}),function(category){
                    try {
                            var detailsJson = JSON.parse(_.get(category,'detailsJson'),[]);

							if(_.get(detailsJson,'length') > 0){

								var apiVesrion = _.get(detailsJson,'[0].apiVersion');
								return _.isEqual(apiVesrion,'v1.3') || _.isEqual(apiVesrion,'v1.0');
							}

							// if we didn't get the api version , we will return false and not include the category
							return false;

					}catch(e){
						console.log("falied to parse code file question category detailsJson : "+_.get(category,'code')+", but allowing category anyway.");
						return false;
					}
			});
	     //----------------------------------------------------------

			$s.veterinarian = ""; 
			
			//$s.minTargetDate = moment().set('hour',0,).set('minute',0).set('second',0).set("millisecond").toDate();//formatDate(new Date());
			$s.minTargetDate = moment().set({'hour':0,'minute':0,'second':0,"millisecond":0}).toDate();//formatDate(new Date());
			$s.pregRateQuestionId = 145;
			$s.concRateQuestionId = 127;

			$s.canUpdate = false;
			$s.canView = false;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			// flag for that is set true when and update answers call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

		    $s.checkSyncStatusTimer = undefined;
			
			
			$s.checkPermissions = function checkPermissions(callback){

				
				
				if(  (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'))) 
				  || (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'))) 
				  || (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','ADMIN')) && viewAuth.hasPersonType(mySynchEnumSvc.getMySynchEnumeration('PersonType','VET')))){
					$s.canView = true;
				}

				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: self.auditId},'Name');
					 
					if(_.isEqual(_.get(auditHerd,'PersonId'),_.get(cookies.user,'PersonId'))){
						$s.canUpdate = true;
					
					}

					callback();

				});
			};

			function formatDate(date){
				var formattedDate = null;
				if(!_.isNull(date)){					
				
					formattedDate = moment(date).toDate();
			
				}
				 
				return formattedDate;
			}
			$s.formatLocalDateString = function(dateTimeString){

			//		var containsTime = dateTimeString.indexOf("T") >= 0;
			//		var dateString  = dateTimeString;
			//		if(containsTime){
				//		dateString  = dateTimeString.substring(0,dateTimeString.indexOf("T"));
			//		}
				 
					//return dateString.replace(new RegExp("-","g"),"/");
					return moment(dateTimeString).subtract(moment(dateTimeString).utcOffset(), 'minutes').format('M/D/YYYY');//moment(dateTimeString).format('M/D/YYYY')				
				};
			function formatDateString(date){
				var stringDate = null;
				if(!_.isNull(date)){
					stringDate = moment(date).format('M/D/YYYY');
					//stringDate = moment(date).subtract(moment(date).utcOffset(), 'minutes').utc().format();//$filter("date")(date,'MM-dd-yyyy');
			   }
				return stringDate;
			}
			function getDaysInMonth(year, month) {
			   return new Date(year, month, 0).getDate();	
			}
			function getMaxNextEvaluationDate(input,months){
				const date = new Date(input);
				date.setDate(1);
				date.setMonth(date.getMonth() + months);
				date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)));
				return formatDate(date);
			}

			$s.getAssociatedMetricsStringList = function getAssociatedMetricsStringList(metricsArray,fieldName,seperator){
				var stringList = "";
				if(_.get(metricsArray,'length') > 0){

					var fieldCodes = _.pluck(metricsArray,fieldName);
					var dispalyValues = _.map( fieldCodes,function(metricCode){
												var displayMetricName = metricCode;
														var metricCodeValue = _.get(_.find($s.codeFile,{codeType: "ACTIONITEMMETRIC",code:metricCode}),'codeValue');
														if(!_.isUndefined(metricCodeValue)){
															displayMetricName = metricCodeValue;
														}
														return displayMetricName;
											});
					if(_.get(dispalyValues,'length') > 0){
						stringList = dispalyValues.join(seperator);
					}
					
				}
			
				return stringList;
			};

			function buildReportData(){

                     
				



				

				$s.actionItemStatuses = _.sortBy(_.filter($s.codeFile,{codeType:"ACTIONSTATUS"}),'dropDownSeq');
			   
				// resultsWriteRptJson data 

				// in the database next evaluation date is stored as a string, the date input control requires a date
				_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get($s.reportData,'resultsWriteRptJson.formattedHighlights',""));
				//_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',formatDate(_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',"")));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',""));
				
				var resultsWriteRptData = _.get($s.reportData,'resultsWriteRptJson');
				if(!_.isUndefined(resultsWriteRptData)){
					_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get(resultsWriteRptData,'formattedHighlights',""));
					_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get(resultsWriteRptData,'nextEvaluationDate',""));
					
	
					_.forEach($s.report.resultsWriteRptJson.comments,function(comment,index){
						_.set(comment,'formattedComments',_.get(resultsWriteRptData,'comments['+index+'].formattedComments',""));
					});
				}
	
				
 
				 // reviewDraftRptJson data and report specific reviewDraftRptJson data
			//	_.set($s.report,'reviewDraftRptJson.reportDate',$s.reportDate);

			      
			        setVeterinarianName();
					
				

					_.set($s.report,'reviewDraftRptJson.reportDate',formatDateString(_.get($s.reportData,'reviewDraftRptJson.reportDate',"")));
					_.set($s.report,'reviewDraftRptJson.milkingCnt', _.get($s.reportData,'reviewDraftRptJson.milkingCnt'), "");
					_.set($s.report,'reviewDraftRptJson.pregRate',getRateValueByQuestionId($s.pregRateQuestionId));		
					_.set($s.report,'reviewDraftRptJson.concRate',getRateValueByQuestionId($s.concRateQuestionId));

					// action item groups and items
					_.set($s.report,'reviewDraftRptJson.actionItemGroups',_.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]));
				    $s.actionItemGroups =  _.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]);

					_.forEach($s.actionItemGroups,function(actionItemGroup){
						_.set(actionItemGroup,'AssociatedMetricsDisplay',
							$s.getAssociatedMetricsStringList(_.get(actionItemGroup,'AssociatedMetrics',[]),"Metric",",")
					     );
					});

					$s.breadcrumbs = f360Service.getReport360Breadcrumbs(formatDateString(_.get($s.report,'reviewDraftRptJson.reportDate')));
			        $s.lastBreadcrumbs = $s.breadcrumbs.pop();
				

			}
			function loadCurrentHerd(callback){
				   
				  auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
						if (err) {
							console.log('err', err);
						}
							$s.currentHerd =  herd[0];
							var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
									   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
						
							  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
								 MSF.loadPage('Login');
							  }
				
						callback();       
				  });

			   
			}
			function setVeterinarianName(){

				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: self.auditId},'Name');  
					$s.veterinarian = _.get(auditHerd,'Name',"");
					$s.$applyAsync();
				});

			}
			
			function getRateValueByQuestionId(questionId){
				var rateValue = "";
				var answer = _.find($s.auditAnswers,{QuestionId:questionId});

				if(answer){
				   var value = _.get(answer,'AnswerDetailsJson.Value',"");
				   if(!_.isNull(value) && !_.isEqual(value,"")){
					   rateValue = value;
				   } 
				}

                return rateValue;
			} 
			function removeExcludedQuestions(){
				var notApplicableQuestion = _.find($s.auditQuestions, function(question) {
					return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
				  
				  });
			 if(!_.isUndefined(notApplicableQuestion)){
				  var notApplicableQuestionAnswer = _.find($s.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
				  if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue)){
					  //if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
					   var excludedQuestionIds = [];
					   var subHeadingQuestions = _.filter($s.auditQuestions,{SubHeading: notApplicableQuestion.SubHeading});
					   _.forEach(subHeadingQuestions,function(subHeadingQuestion){
						  var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
						  
						  if(!_.isNull(calcTags)){
							  _.forEach(calcTags,function(calcTag){
								 
								  var calcQuestion = _.find($s.auditQuestions,function(question){ 
													  
														  var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
														  if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
																  var valueTagObjects = [];
	
																  _.forEach(calcVarArray,function(calcVarObject){
																	  var calcVarObjectKey = _.keys(calcVarObject)[0];
																	  valueTagObjects.push(calcVarObject[calcVarObjectKey]);
																	  //var valueTagArray = calcVarObject[calcVarObjectKey].valueTag;
																  //	valueTags = _.union(valueTags,valueTagArray);
																	  
																  });
																  var calcQuestionMatch = false;
																  _.forEach(valueTagObjects,function(valueTagObject){
																	  if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																		  calcQuestionMatch = true;
																		  return false;		
																	  }
	
																  });
	
	
																  return calcQuestionMatch;
														  }
													   
														  
													  });
									 if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
										 excludedQuestionIds.push(calcQuestion.QuestionId);
									 }	
							  });
						  }
						  
					   });
	
					  
					  // then  we want to exclude the questions in that subheading for the counts on the overview screen
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.SubHeading,notApplicableQuestion.SubHeading) || _.includes(excludedQuestionIds,question.QuestionId);});
	
					 
					 
				  }else{
					  //even if the not applicable question is false, we still don't want to include it in the answer count
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.QuestionId,notApplicableQuestion.QuestionId);});
				  }	   
			 }
			}
			function loadPieCharts(){
				//all data for pie charts are for questions that have an industry guideline
				
				// overall summary pie chart 
				_.set($s.overallSummaryPieChart,'title',"Questions that Met Industry Guideline");
				
			//	 $s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
			//	 $s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
				
				 // these two lines are being left in to check on the accuracy of the chart data values based on the question property used here to filter.
				// $s.metGuidlineQuestionsNoIndustry = _.filter($s.allMetGuidelineQuestions,function(question){ return _.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) || _.isNull(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
				// $s.outsideGuidelineQuestionsNoIndustry = _.filter($s.allOutsideGuidelineQuestions,function(question){ return _.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) || _.isNull(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});

				var overallSummaryQuestionData = [
					{name: "Met Guideline", data: $s.allMetGuidelineQuestionsWithGuidelines.length},
					{name: "Did Not Meet Guideline", data: $s.allOutsideGuidelineQuestionsWithGuidelines.length}
				];
				_.set($s.overallSummaryPieChart,'seriesData',overallSummaryQuestionData);

				var overallPieChartCanvasElement = document.getElementById("overallSummaryPieChart");// $('#overallSummaryPieChart')[0];
				var overallPieChartElement = overallPieChartCanvasElement.getContext('2d');
				
				var overallPieChartOptions = {
					title:{
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
			$s.overallSummaryPieChart.chart = ChartService.getCircleChart(overallPieChartElement, overallPieChartOptions,$s.overallSummaryPieChart.seriesData, $s.overallSummaryPieChart.title);

			_.forEach($s.sectionsQuestionsAndAnswers,function(section){
									 
				var sectionChart = {
					chart: {},
					title: "",
					seriesData: [] 
				};
				_.set(sectionChart,'title',section.sectionName+" Questions that Met Industry Guideline");

				var allMetGuidelineQuestionsWithGuidelines = _.filter(section.metGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
				var allOutsideGuidelineQuestionsWithGuidelines = _.filter(section.outsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         

				var seriesData = [
					{name: "Met Guideline", data: allMetGuidelineQuestionsWithGuidelines.length},
					{name: "Did Not Meet Guideline", data: allOutsideGuidelineQuestionsWithGuidelines.length}
				];
				_.set(sectionChart,'seriesData',seriesData);
				
				var sectionPieChartCanvasElement = document.getElementById("circle-chart-"+section.sectionName);
				var sectionPieChartElement = sectionPieChartCanvasElement.getContext('2d');
				
				var sectionPieChartOptions = {
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
				var chart = ChartService.getCircleChart(sectionPieChartElement, sectionPieChartOptions,sectionChart.seriesData, sectionChart.title);
				_.set(sectionChart,'chart',chart);
				$s.sectionPieCharts.push(sectionChart);


			});
						
			}

			function loadBarCharts(){
				
				// section bar chart 
				_.set($s.sectionBarChart,'title',["Questions that Met Industry Guideline by Evaluation Section"]);
				//_.set($s.sectionBarChart,'title',["Questions that Met Industry Guideline","by Evaluation Section"]);

				
			 
				
			var sectionBarChartData = {
					categoryLabels: [],
					seriesData : []

			};
				
				 var metGuidelineQuestionsDataBySection = [];
				 var outsideGuidelineQuestionsDataBySection = [];
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
				
				sectionBarChartData.categoryLabels.push(_.get(section,'sectionName',""));
				
					
					
				  
					var allMetGuidelineQuestionsWithGuidelines = _.filter(section.metGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
					var allOutsideGuidelineQuestionsWithGuidelines = _.filter(section.outsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         

					metGuidelineQuestionsDataBySection.push(allMetGuidelineQuestionsWithGuidelines.length);
					outsideGuidelineQuestionsDataBySection.push(allOutsideGuidelineQuestionsWithGuidelines.length);
				});


				//sectionBarChartData.categoryLabels.push("test");
				//sectionBarChartData.categoryLabels = ["a","b","c","d","e","f"];
			//	metGuidelineQuestionsDataBySection.push(15);
				//outsideGuidelineQuestionsDataBySection.push(15);
				
			
					
				sectionBarChartData.seriesData.push({
					 label: "Met Guideline",
					 data: metGuidelineQuestionsDataBySection,
					 backgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
					 borderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
					 borderWidth: _.times(metGuidelineQuestionsDataBySection.length,_.constant(1)),
					 hoverBackgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
					 hoverBorderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
				},{
					label: "Did Not Meet Guideline",
					data: outsideGuidelineQuestionsDataBySection,
					backgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
					borderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
					borderWidth: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant(1)),
					hoverBackgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
					hoverBorderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
				});

			

				_.set($s.sectionBarChart,'seriesData',sectionBarChartData);

				var sectionStepSize = 5;

				var sectionBarChartOptions = {
					title: {
						display: true,
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
						
					},
					scales: {
						xAxes: [{
						   stacked: false,
						   categoryPercentage: 1.0,
						   barPercentage: 0.75,
						   ticks: {
							   autoSkip: false,
							   //max: _.max(_.map(_.map($s.sectionBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) })) + sectionStepSize,
						   },
						   afterSetDimensions: function(axes) {
							  // console.log("Inside afterSetDimensions");
						    	//console.log(axes);
							//    axes.maxWidth = 165;
							   // console.log(axes.width);
				        	}
							}]
					  },
					tooltips:{
						enabled: false
					}
				};

			   var sectionBarChartCanvasElement = document.getElementById("sectionBarChart");
			   var sectionBarChartElement = sectionBarChartCanvasElement.getContext('2d');
			   $s.sectionBarChart.chart  =  ChartService.getBarChart(sectionBarChartElement,sectionBarChartOptions, $s.sectionBarChart.seriesData, $s.sectionBarChart.title,sectionStepSize);
			  
			   // Question Category Chart

			   _.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline by Category"]);
			 
			   //_.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline","by Category"]);


			   var metGuidelineQuestionsSeriesDataByCategory = [];
			   var outsideGuidelineQuestionsSeriesDataByCategory = [];

			   var allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
			   var allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         
		 
			 
			   _.forEach($s.codeFileQuestionCategories,function(codeFileCategory){
					 
				var metGuidelineQuestionsByCategory = _.filter(allMetGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
				metGuidelineQuestionsSeriesDataByCategory.push(metGuidelineQuestionsByCategory.length);

				var outsideGuidelineQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
				outsideGuidelineQuestionsSeriesDataByCategory.push(outsideGuidelineQuestionsByCategory.length);
					 
			 });

			 var categoryBarChartData = {
			  categoryLabels: _.map($s.codeFileQuestionCategories,function(codeFileCategory){ return _.get(codeFileCategory,'codeValue');}),
			  seriesData : []

			 };
			   
				

			   categoryBarChartData.seriesData.push( {
				label: "Met Guideline",
				data: metGuidelineQuestionsSeriesDataByCategory,
				backgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderWidth: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
				hoverBackgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
				hoverBorderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
		   },{
			   label: "Did Not Meet Guideline",
			   data: outsideGuidelineQuestionsSeriesDataByCategory,
			   backgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderWidth: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
			   hoverBackgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
			   hoverBorderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
		   });

		   _.set($s.categoryBarChart,'seriesData',categoryBarChartData);

		  var categoryStepSize = 5;

		   var categoryBarChartOptions = {
			   title: {
				   display: true,
				   fontSize: 14
			   },
			   legend:{
				   labels:{
					   boxWidth: 15
				   },
				   position: "bottom"
				   
			   },
			   scales: {
				 xAxes: [{
					stacked: false,
					categoryPercentage: 1.0,
					barPercentage: 0.75,
					ticks: {
						autoSkip: false,
						suggestedMax: 40
						//max: _.ceil(_.max(_.map(_.map($s.categoryBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) }))/5)*5 + categoryStepSize,
					}
					 }]
			   },
			   tooltips:{
				   enabled: false
			   }
		   };

		  var categoryBarChartCanvasElement = document.getElementById("categoryBarChart");
		  var categoryBarChartElement = categoryBarChartCanvasElement.getContext('2d');
		  $s.categoryBarChart.chart  =  ChartService.getBarChart(categoryBarChartElement,categoryBarChartOptions, $s.categoryBarChart.seriesData, $s.categoryBarChart.title, categoryStepSize);
		
		  


			}

			function loadReportCharts(){
				var sectionChartCanvasJQOs = $('[id^="circle-chart-"]');

				if(sectionChartCanvasJQOs.length > 0){
					loadPieCharts();
					loadBarCharts();
				}else{
					var deregSectionChartCanvasInterval = $interval(function()
					{
						sectionChartCanvasJQOs = $('[id^="circle-chart-"]');
						var sectionChartCanvasExists = sectionChartCanvasJQOs.length > 0;
						
						if(sectionChartCanvasExists){
							loadPieCharts();
							loadBarCharts();
							$interval.cancel(deregSectionChartCanvasInterval);
						}
						
					},100);
				}
			}

			function buildSectionsQuestionsAndAnswers(){
				
				_.forEach($s.overViewList,function(section){
					var sectionQuestionAnswerObj = {}; 
					var sectionName = $filter("SectionName")(section.Section);
					_.set(sectionQuestionAnswerObj,'sectionName',sectionName);
					var sectionQuestions = _.filter($s.auditQuestions,function(question){return question.Section === section.Section && question.QuestionId != 1;});
					var metGuidelineQuestions = [];
					var outsideGuidelineQuestions = [];
	
					_.forEach(sectionQuestions,function(question){
						var answer = _.get(_.find($s.auditAnswers,{QuestionId: question.QuestionId}),'AnswerDetailsJson');

						 // need to convert the date proprties from their string form to date form 
						 _.set(answer,'TargetDate',formatDate(_.get(answer,'TargetDate',null))); 

						 // set initial value of the Status property
					  if( _.isNull(_.get(answer,'Status',null))){	 
						 if(_.isEqual(_.get(answer,'MgmtAccepted'),true)){
							// if the action item was "Accepted By Producer", then initial Status is the code of Not Started 
							_.set(answer,'Status','NOTSTART');
						 }else{
							 // otherwise, status starts out as the code of Declined
							_.set(answer,'Status','DECLINED');
						 }
						}

						
						_.set(question,'Answer',angular.copy(answer));
	
					
	 
						
						if(_.isEqual(question.Answer.MetGuideline,false)){
							outsideGuidelineQuestions.push(question);
						}else{
							metGuidelineQuestions.push(question);
						}
						
					});
	
					_.set(sectionQuestionAnswerObj,'metGuidelineQuestions',metGuidelineQuestions);
					_.set(sectionQuestionAnswerObj,'outsideGuidelineQuestions',outsideGuidelineQuestions);
					
					$s.sectionsQuestionsAndAnswers.push(sectionQuestionAnswerObj);
					$s.allOutsideGuidelineQuestions = $s.allOutsideGuidelineQuestions.concat(outsideGuidelineQuestions);
					$s.allMetGuidelineQuestions = $s.allMetGuidelineQuestions.concat(metGuidelineQuestions);
	
				}); 

				$s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
		    	$s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
		  
			
			}
	
			// function that loads the action items on load of the results and write report screen
			function loadActionItems(){
				
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					 
					 _.forEach(section.outsideGuidelineQuestions,function(question){
						 if(_.get(question,'Answer.ActionItem')){
							 $s.actionItems.push(question);
						 }
					 });
	
	
					 _.forEach(section.metGuidelineQuestions,function(question){
						if(_.get(question,'Answer.ActionItem')){
							$s.actionItems.push(question);
						}
					});
	
	
				});
				
			}

			// function that loads the followup items on load of the results and write report screen
			function loadFollowupItems(){
				
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					 
					 _.forEach(section.outsideGuidelineQuestions,function(question){
						 if(_.get(question,'Answer.FollowUp')){
							 $s.followupItems.push(question);
						 }
					 });
	
	
					 _.forEach(section.metGuidelineQuestions,function(question){
						if(_.get(question,'Answer.FollowUp')){
							$s.followupItems.push(question);
						}
					});
	
	
				});
				
			}

		

			$s.printReport = function printReport(){
				$window.print();
			};

			$s.onActionItemStatusChange = function onActionItemStatusChange(question){
				var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
					auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 

					// we need to convert answer date fields to a string format before saving. 
					_.set(auditAnswer,'AnswerDetailsJson.TargetDate',formatDateString(_.get(question,'Answer.TargetDate',null))); 

					$s.updateAnswers();	
			};
			

			$s.updateAnswers = function updateAnswers(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;	
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress === true;
						log.info("updateAnswer: start");

						
			
						var AnswerJson = JSON.stringify($s.auditAnswers);

						$s.isDirty = true;
						auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error getting F360 online check: ' + err);
								$s.isDirty = false;
							}else{
							$s.updateInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 736");
								$s.finalSaveRequired = false;
								$s.updateAnswers();
							}
							log.info("answerUpdate: update of answer failed, update end");
							
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){

													
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});

									log.info("answerUpdate: updating last synced date with : ");
									log.info(auditlistItem);

									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											
											$s.updateInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 767");
												$s.finalSaveRequired = false;
												$s.updateAnswers();
											}
											log.info("answerUpdate: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("answerUpdate: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 777");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
									    }
									
									}

								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									$s.updateInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 793");
										$s.finalSaveRequired = false;
										$s.updateAnswers();
									}
									log.info("answerUpdate: offline and updated is dirty flag, update end");
								});
							}
								
								
								console.log('update ok');
						}
						});
					});
				}else{
					log.info("an answer save attempt was made while another one was going");
					$s.finalSaveRequired = true;
					
				}
				
			};
			//function that constructs the display value of a given text value  
			$s.getTextDisplayValue  = function getTextDisplayValue(text){

				// replace any measurement standard text 
				var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

				text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

				return text;

			};
			// function that formats a questions answer value and returns the formatted value
			$s.formatAnswer = function(question){
			
				var formattedAnswerValue = "";
	
				var questionTemplate = _.get(question,'QuestionTemplate',"");
				var answerValue = _.get(question,'Answer.Value',"");
				var codeType = _.get(question,'CodeType',"");
	
				switch(questionTemplate){
					case "%3,0":
					case "%5,1":
						formattedAnswerValue = answerValue + '%';
					break;
					case "SINGL":
						formattedAnswerValue = _.get(_.find($s.codeFile,{codeType: codeType,code: answerValue}),'codeValue',answerValue); 
					break;
					case "YN":
					   if(answerValue === "Y"){
						   formattedAnswerValue = "Yes";
					   }else if(answerValue === "N"){
						   formattedAnswerValue = "No";
					   } 
					break;
					case "MULTI":
						var valueList = answerValue;
						valueList = valueList.replace(/["()']/g,""); 
						//then we create an array to compare value to 							
						var values = valueList;
						values = valueList.split(',');
						// if the code type for the question was MONTH we need to order the values by calendar order
						if(_.isEqual(question.CodeType,"MONTH")){
						
						 var months = _.filter($s.codeFile,{codeType:"MONTH"});
		
						 values = _.sortBy(values, x => _.findIndex(months, y => _.isEqual(x,y.code))); 
						}
	
						// the values we want to dispaly in the grid is the codeValue(s)(button label) of the code(s)(answer choice) chosen. 
						values = _.map(values,function(value){
						
							var displayValue = _.get(_.find($s.codeFile,{code: value}),'codeValue',value);
							if(_.isEqual(displayValue,"None")){
								displayValue = _.get(question,'QuestionDetailsJson.industryGuideline.description');
							}
							return displayValue; 
						});
						values = values.join(', ');
	
	
						formattedAnswerValue = values;
		
					break;
					default:
					  formattedAnswerValue = answerValue;
	
				}
				return formattedAnswerValue;
			};
			$s.formatIndustryGuideline = function(guideline){
	  
				 var formattedGuideline = "";
				switch(guideline){
					case "---":
					case undefined:{
						formattedGuideline = "N/A";
					break;
					}
					default:
						formattedGuideline = guideline;
					break;	
				}
				return formattedGuideline;
			};
			$s.validateTargetDate = function(question){
				var validTargetDate = false;
                  if(_.isEqual(_.get(question,'Answer.MgmtAccepted'),true)){
					  var targetDate = _.get(question,'Answer.TargetDate',null);
					   // the target date is required if MgmtAccepted is true and cannot be in the past
					  if((!_.isNull(targetDate)) && (targetDate >= $s.minTargetDate)){
						  validTargetDate = true;
					  }
					
				  }else{
					validTargetDate = true;
				  }

                  if(validTargetDate === false){
					$("#target-date-label-"+question.QuestionId).addClass('text-red');
					$("#target-date-container-"+question.QuestionId).addClass('error-container');
					$("#errorInputvalidateTargetDate-"+question.QuestionId).removeClass('dis-none');
				}else{
					$("#target-date-label-"+question.QuestionId).removeClass('text-red');
					$("#target-date-container-"+question.QuestionId).removeClass('error-container');
					$("#errorInputvalidateTargetDate-"+question.QuestionId).addClass('dis-none');
					var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
						auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 

						// we need to convert answer date fields to a string format before saving. 
						_.set(auditAnswer,'AnswerDetailsJson.TargetDate',formatDateString(_.get(question,'Answer.TargetDate',null))); 

					$s.updateAnswers();	
				}


				return validTargetDate;
			};

			

			$s.addQuestionCategories = function(){
				//test interval 22
				var firstIntervalStartIndex = 2;
				var secondIntervalStartIndex = 25;
				var thirdIntervalStartIndex = 48;
				var fourthIntervalStartIndex = 71;
				var fifthIntervalStartIndex = 94;
				var sixthIntervalStartIndex = 117;
	
				_.forEach($s.auditQuestions,function(question){
					switch(true){
						case  (question.QuestionId >= 2 && question.QuestionId < 25):
						  _.set(question,'category','Cow Comfort');
						break;
						case (question.QuestionId >= 25 && question.QuestionId < 48):
							_.set(question,'category','Data Quality');
							break;
						case (question.QuestionId >= 48 && question.QuestionId < 71):
							_.set(question,'category','Fertility');
							break;
						case (question.QuestionId >= 71 && question.QuestionId < 94):
							_.set(question,'category','Nutrition');
							break;		
						case (question.QuestionId >= 94 && question.QuestionId < 117):
							_.set(question,'category','Personnel');
							break;
						case (question.QuestionId >= 117 && question.QuestionId < 140):
							_.set(question,'category','Transition Cow');
							break;
						case (question.QuestionId >= 141):
							_.set(question,'category','Unassigned');
							break;		
	
					}
				});
				
			};

		function loadReportData(){
			auditService.getListByHerdId(function(err, auditListData){


                var auditData = _.find(auditListData,{AuditId: self.auditId});

				$s.auditApiVersion = _.get(auditData,'ApiVersion',$s.currentAuditApiVersion);

				auditService.getIndexedDBReviewResultsAndDraft(self.auditId, function getIndexedDBReviewResultsAndDraft(err, data) {
					if (err) {
						log.error('error getting F360 Review Results And Draft Data: ' + err);
						MSF.confirmation.danger(err,false);
					}
		
					if (data && data.length) {
						//var reportData = {};
						try{
						$s.reportData =	JSON.parse(data);
						}catch(e){
							console.log("failed to parse report date");
						}
		
						if (!window.navigator.onLine) {
							$s.$apply();
						}
					}
		
						auditService.getIndexedDBOverViewList(self.auditId, function getIndexedDBOverViewList(err, data) {
							if (err) {
								log.error('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
								
							}
							if (data && data.length) {
								$s.overViewList = data;
								for (let index = 0; index < $s.overViewList.length; index++) {
									$s.overViewList[index].AnswerCnt = 0;
									$s.overViewList[index].QuestionCnt = 0;
								}
								if (!window.navigator.onLine) {
									$s.$apply();
								}
							}
		
								auditService.getIndexedDBQuestionList(self.auditId, function getIndexedDBQuestionList(err, data) {
								if (err) {
									log.error('error getting F360 Over View List: ' + err);
									MSF.confirmation.danger(err,false);
								}
								
								if (data && data.length) {
									var arrQuestion = [];
									var parseDataQuestion = JSON.parse(data);
									var questionDetailsJson = parseDataQuestion.QuestionsJson;
								
									for (let i = 0; i < questionDetailsJson.length; i++) {
										arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
									}
									// we need to order the questions here in the ux because the questions come from a JSON field
									// intead their own records in a table.
									$s.auditQuestions = _.sortByOrder(arrQuestion,['SortOrder'],['asc']);


									//TODO remove this function and this line of code once questions are properly updated with categories
								
									
									
									auditService.getIndexedDBAnswerList(self.auditId, function getIndexedDBAnswerList(err, data) {
										if (err) {
											console.log('error getting F360 Over View List: ' + err);
											MSF.confirmation.danger(err,false);
										}
										if (data && data.length) {
											try{
											$s.auditAnswers = JSON.parse(data);
											}catch(e){
											log.error("failed to parse answer list json : "+_.get(e,'message'," "));
											}
										
										
										} else {
											$s.auditAnswers = [];
										}

										//if the not applicable question is checked we have to exclude certain questions including the NA question itself. 
										removeExcludedQuestions();


										buildSectionsQuestionsAndAnswers();		
                                        if(_.isEqual($s.auditApiVersion,'v1.0')){
											loadActionItems();
										}else{
											loadFollowupItems();
										} 
										 
										
										buildReportData();
										loadReportCharts();
									
										
										//$s.$apply(buildSectionsQuestionsAndAnswers());
										//$s.$apply(loadActionItems());
										//$s.$apply(loadReportData());
										//$s.$apply(loadPieCharts());
									// $s.$apply(loadBarCharts());
							//		$s.$applyAsync(function(){
							//			buildSectionsQuestionsAndAnswers();
										

							//			loadActionItems();
							//			loadReportData();

							//			loadPieCharts();
							//			loadBarCharts();
							//		});
										
		
									});
		
								} else {
									$window.location.href = '#/f360';
								}
							});
						});
					});
				});
			}

           
			

	
			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						  $s.checkF360SyncStatus().then(function(){
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
						
						  });
					  } 
				 }
				 
			 });

			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();
				if ($s.isOnline && $s.updateInProgress === false) {

					
					log.info("checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){

						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}
						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					     //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
						 if(	$s.updateInProgress === true){
							log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
							syncStatusPromise.reject(true);
							   return;
						   }

					   log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, function getF360SyncStatus(err, data) {
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}

								  //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								  if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									   return;
								   }
								
								if (data) {
									self.isSync = true;
								
									var syncData = data[0];	

									if(!_.isUndefined(syncData)){
										//	 _.set(data,'updateDevice',true);	
										log.info("checkedSync: synce data returned with");
										log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														log.info("checkedSync: updating last synced date with : ");
														log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																syncStatusPromise.resolve(true);
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													 syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													syncStatusPromise.resolve(true); 
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										self.isSync = false;
										syncStatusPromise.resolve(true);
									}

								} else {
									self.isSync = false;
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
					self.isSync = false;
					syncStatusPromise.resolve(true);
				}
				return syncStatusPromise.promise;
			};
			


			$s.$on("$destroy", function() {
				deregOnFarmChange();
				deregOnlineCheckWatch();
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});

			MSF.ready(function onMsfReady() {
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));

				console.log("@@@@@@ TESTING I AM IN 1.3 CONTROLLER");

				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion().then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });

				
				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						loadCurrentHerd(function(){
							loadReportData();
						});				
						
					});

				}); 
			
			});
		}
	]);
})();
